/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_Label_PrintedInputs */

const tr_geliver_status_label_printed = /** @type {(inputs: Geliver_Status_Label_PrintedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiket yazdırıldı`)
};

const en_geliver_status_label_printed = /** @type {(inputs: Geliver_Status_Label_PrintedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label printed`)
};

const de_geliver_status_label_printed = /** @type {(inputs: Geliver_Status_Label_PrintedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etikett gedruckt`)
};

const ru_geliver_status_label_printed = /** @type {(inputs: Geliver_Status_Label_PrintedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этикетка напечатана`)
};

/**
* | output |
* | --- |
* | "Label printed" |
*
* @param {Geliver_Status_Label_PrintedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_label_printed = /** @type {((inputs?: Geliver_Status_Label_PrintedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_Label_PrintedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_label_printed(inputs)
	if (locale === "de") return de_geliver_status_label_printed(inputs)
	if (locale === "ru") return ru_geliver_status_label_printed(inputs)
	return tr_geliver_status_label_printed(inputs)
});